import { Stack } from "@mui/material";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { useEffect, useState } from "react";
import { endpointName, ST_TYPE_ID } from "../../const";
import { useDispatch, useSelector } from "react-redux";
import { setList, setServicesCallDetails } from "store/servicesCallSlice";
import { setShowLoading } from "store/sysSlice";
import { apiUrl } from "config/settings";
import useDataManager from "hooks/useDataManager";
import http from '../../../../http'
import SelectEmp from "../SelectEmp";
import Details from "./Details";
import FinishService from "../FinishService";

const GroupData = ({ deleteServicesCall, filterlist, displaySettings, now, createGoogleCalendar }) => {
  const dispatch = useDispatch()
  const { editItem, removeItem } = useDataManager()
  const employees = useSelector((state) => state?.employees?.list);
  const user = useSelector((state) => state.userSettings?.user);
  const list = useSelector((state) => state?.servicesCall.list);
  const [itemList, setItemList] = useState([]);
  const [selectEmp, setSelectEmp] = useState({ open: false, call: null });
  const [finishService, setFinishService] = useState({ open: false, call: null });

  useEffect(() => {
    if (displaySettings) {
      const list = Object.keys(displaySettings?.show).filter(
        (key) => displaySettings?.show[key] == true
      );
      setItemList(list);
    }
  }, [displaySettings]);

  const openService = (call) => {
    dispatch(setServicesCallDetails({ ...call, id: call?._id }))
  }

  const onFinishService = (data) => {
    if (!data?.call?._id) return

    dispatch(setShowLoading(true));

    const obj = {
      stTypeId: ST_TYPE_ID?.CLOSE,
      notes: data?.notes,
      jobDoneDesc: data?.jobDoneDesc,
    }

    http.patch(`${apiUrl}/${endpointName}/${data?.call?._id}`, obj)
      .then((res) => {
        dispatch(setShowLoading(false));
        const newList = removeItem(data?.call?._id, list);
        dispatch(setList(newList));
      })
      .catch((error) => {
        dispatch(setShowLoading(false));
      });
  }

  const editService = (data) => {
    if (!data?.call?._id) return

    dispatch(setShowLoading(true));
    let obj = { hasFlag: data?.hasFlag }

    http.patch(`${apiUrl}/${endpointName}/${data?.call?._id}`, obj)
      .then((res) => {
        dispatch(setShowLoading(false));
        const item = { ...data?.call, ...obj };
        const newList = editItem(item, list);
        dispatch(setList(newList));
      })
      .catch((error) => {
        dispatch(setShowLoading(false));
      });
  }

  return (
    <Stack spacing={2} direction="row" useFlexGap flexWrap="wrap" p={{ xs: 2, md: 0 }} pb={2}>
      {filterlist?.length > 0
        ? filterlist?.map((call, idx) => {
          const associatedEmp = employees?.find(emp => emp?.id === call?.employee)
          return (
            <Details
              createGoogleCalendar={createGoogleCalendar}
              key={idx}
              call={call}
              now={now}
              openService={openService}
              setOpenFinishService={setFinishService}
              user={user}
              itemList={itemList}
              editService={editService}
              associatedEmp={associatedEmp}
              setSelectEmp={setSelectEmp}
              deleteServicesCall={deleteServicesCall}
            />
          );
        })
        : <Stack></Stack>
      }

      {selectEmp
        ? <SelectEmp
          data={selectEmp}
          setData={setSelectEmp}
          list={list}
        />
        : null
      }

      {finishService
        ? <FinishService
          data={finishService}
          setData={setFinishService}
          onFinishService={onFinishService}
        />
        : null
      }
    </Stack>
  );
};
export default GroupData;
